import { render, staticRenderFns } from "./CustomerMetricsReportForm.vue?vue&type=template&id=9275d47e&scoped=true&"
import script from "./CustomerMetricsReportForm.vue?vue&type=script&lang=js&"
export * from "./CustomerMetricsReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9275d47e",
  null
  
)

export default component.exports